import React, { useState } from "react";
import styles from "./PropertiesPanel.module.css";

export default function PropertiesPanel({
  page,
  onUpdatePageField,
  onDeletePage,
  canDeletePage,
  panel,
  panelIndex,
  onUpdatePanelText,
  onUpdatePanelDuration,
  onDuplicatePanel,
  onDeletePanel,
  canDeletePanel,
}) {
  const [tab, setTab] = useState("panel"); // "panel" | "page"

  return (
    <aside className={styles.panel}>
      <div className={styles.tabs}>
        <button
          className={`${styles.tab} text-label-sm ${tab === "panel" ? styles.tabActive : ""}`}
          onClick={() => setTab("panel")}
        >
          Frame
        </button>
        <button
          className={`${styles.tab} text-label-sm ${tab === "page" ? styles.tabActive : ""}`}
          onClick={() => setTab("page")}
        >
          Página
        </button>
      </div>

      <div className={styles.content}>
        {tab === "panel" && panel && (
          <>
            <Section icon="image" title={`Frame ${panelIndex + 1}`}>
              <Field label="Duración">
                <div className={styles.inputWithSuffix}>
                  <input
                    type="number"
                    min={0.1}
                    step={0.1}
                    value={panel.duration ?? 2.5}
                    onChange={(e) => onUpdatePanelDuration(panel.id, e.target.value)}
                  />
                  <span>seg</span>
                </div>
              </Field>

              <Field label="Texto / diálogo" align="start">
                <textarea
                  className={styles.textarea}
                  value={panel.text}
                  placeholder="Describe la acción o el diálogo…"
                  onChange={(e) => onUpdatePanelText(panel.id, e.target.value)}
                />
              </Field>
            </Section>

            <div className={styles.actionsRow}>
              <button
                className={`${styles.secondaryAction} text-label-md`}
                onClick={() => onDuplicatePanel(panel.id)}
              >
                <span className="material-symbols-outlined" style={{ fontSize: 16 }}>
                  content_copy
                </span>
                Duplicar
              </button>
              <button
                className={`${styles.destructiveAction} text-label-md`}
                onClick={() => onDeletePanel(panel.id)}
                disabled={!canDeletePanel}
                title={!canDeletePanel ? "La página debe tener al menos un frame" : undefined}
              >
                <span className="material-symbols-outlined" style={{ fontSize: 16 }}>
                  delete
                </span>
                Eliminar frame
              </button>
            </div>
          </>
        )}

        {tab === "page" && page && (
          <>
            <Section icon="auto_stories" title="Información de página">
              <Field label="Título" align="start">
                <input
                  className={styles.input}
                  value={page.title}
                  onChange={(e) => onUpdatePageField("title", e.target.value)}
                />
              </Field>
              <Field label="Descripción" align="start">
                <textarea
                  className={styles.textarea}
                  value={page.description}
                  onChange={(e) => onUpdatePageField("description", e.target.value)}
                />
              </Field>
            </Section>

            <div className={styles.actionsRow}>
              <button
                className={`${styles.destructiveAction} text-label-md`}
                onClick={() => onDeletePage(page.id)}
                disabled={!canDeletePage}
                title={!canDeletePage ? "Debe quedar al menos una página" : undefined}
              >
                <span className="material-symbols-outlined" style={{ fontSize: 16 }}>
                  delete
                </span>
                Eliminar página
              </button>
            </div>
          </>
        )}
      </div>
    </aside>
  );
}

function Section({ icon, title, children }) {
  return (
    <div className={styles.section}>
      <div className={`${styles.sectionTitle} text-body-sm`}>
        <span className="material-symbols-outlined" style={{ fontSize: 14 }}>
          {icon}
        </span>
        <span>{title}</span>
      </div>
      <div className={styles.sectionBody}>{children}</div>
    </div>
  );
}

function Field({ label, children, align = "center" }) {
  return (
    <div className={styles.field} style={{ alignItems: align === "start" ? "start" : "center" }}>
      <label className="text-label-sm">{label}</label>
      {children}
    </div>
  );
}
